<template>
  <section class="page-dashbord-course-form mt-3">
    <app-loading :isFull="true" v-if="isLoading" />
    <div class="container">
      <div class="row">
        <div class="col-12">
          <header>
            <h2 class="text-right rtl font-18 mb-4">اطلاعات اولیه دوره</h2>
          </header>
          <div class="wrapper-form shadow py-4 mb-4">
            <div class="row px-2">
              <div class="col-12">
                <div class="row">
                  <div class="col-6 mb-5">
                    <upload-avatar
                      :scale="scaleImage"
                      pixelImage="245*190px"
                      :defultFile="form.Img ? appUrl.media + '/' + form.Img :defaultImg"
                      @getFile="getFile"
                      :height="'250'"
                    />
                  </div>
                </div>
                <b-progress
                  :value="uploadPercentage "
                  class="mt-2 w-100"
                  v-if="uploadPercentage> 0"
                  :variant="'info'"
                ></b-progress>
              </div>
              <div class="col-6">
                <div class="group-form">
                  <input
                    maxlength="120"
                    type="text"
                    v-validate="'required'"
                    name="course_title"
                    :class="{active:form.course_title != '' }"
                    v-model="form.course_title"
                  />
                  <span class="bar"></span>
                  <label class="statr">نام دوره</label>
                  <span v-if="errors.has('course_title')" class="is-danger">فیلد نباید خالی باشد</span>
                </div>
              </div>
              <div class="col-6">
                <div class="group-form">
                  <input
                    maxlength="120"
                    type="text"
                    v-validate="'required'"
                    name="course_title_en"
                    :class="{active:form.course_title_en != '' }"
                    v-model="form.course_title_en"
                  />
                  <span class="bar"></span>
                  <label class="statr">نام دوره به انگلیسی</label>
                  <span v-if="errors.has('course_title_en')" class="is-danger">فیلد نباید خالی باشد</span>
                </div>
              </div>
              <div class="col-12">
                <div class="editor rtl text-right my-4">
                  <label class="statr">توضیح مختصر در مورد دوره</label>
                  <tinymce-editor
                    v-model="form.course_description_lite"
                    api-key="5jvyaeru3nfs1qb04au0hymmsfyrhspqo7qg0xp8cnc8ptl6"
                    :init="configBase"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="editor rtl text-right my-4">
                  <label class="statr">توضیح کامل در مورد دوره</label>
                  <tinymce-editor
                    v-model="form.course_description"
                    api-key="5jvyaeru3nfs1qb04au0hymmsfyrhspqo7qg0xp8cnc8ptl6"
                    :init="configBase"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="editor rtl text-right my-4">
                  <label class="statr">مدت زمان دوره</label>
                </div>
              </div>
              <div class="col-2">
                <div class="group-form mod-ltr">
                  <input
                    type="text"
                    v-validate="'required|numeric|max:2'"
                    name="ثانیه"
                    :class="{active:duration.s != '' }"
                    v-model="duration.s"
                    maxlength="2"
                  />
                  <span class="bar"></span>
                  <label class="statr">ثانیه</label>
                  <span v-if="errors.has('ثانیه')" class="is-danger">*</span>
                </div>
              </div>
              <div class="col-2">
                <div class="group-form mod-ltr">
                  <input
                    type="text"
                    v-validate="'required|numeric|max:2'"
                    maxlength="2"
                    name="دقیقه"
                    :class="{active:duration.m != '' }"
                    v-model="duration.m"
                  />
                  <span class="bar"></span>
                  <label class="statr">دقیقه</label>
                  <span v-if="errors.has('دقیقه')" class="is-danger">*</span>
                </div>
              </div>
              <div class="col-2">
                <div class="group-form mod-ltr">
                  <input
                    type="text"
                    v-validate="'required|numeric'"
                    name="ساعت"
                    :class="{active:duration.h != '' }"
                    v-model="duration.h"
                  />
                  <span class="bar"></span>
                  <label class="statr">ساعت</label>
                  <span v-if="errors.has('ساعت')" class="is-danger">*</span>
                </div>
              </div>
              <div class="col-5">
                <span v-if="errors.has('ثانیه')" class="validTime">{{errors.first('ثانیه')}}</span>
                <span v-if="errors.has('دقیقه')" class="validTime">{{errors.first('دقیقه')}}</span>
                <span v-if="errors.has('ساعت')" class="validTime">{{errors.first('ساعت')}}</span>
              </div>
              <div class="clearfix my-5"></div>
              <div class="col-4">
                <div class="group-form">
                  <input
                    type="text"
                    v-validate="'required|numeric'"
                    name="course_price"
                    :class="{active:form.course_price != '' }"
                    v-model="form.course_price"
                  />
                  <!-- <money v-model="cost" v-bind="money" class="text" v-model.lazy="form.course_price" :class="{active:form.course_price != '' }"></money> -->
                  <span class="bar"></span>
                  <label class="statr">هزینه ی دوره</label>
                  <span v-if="errors.has('course_price')" class="is-danger">فیلد نباید خالی باشد</span>
                </div>
              </div>
              <div class="col-6">
                <div class="group-form text-center pt-3">
                  <span
                    v-if="form.course_price"
                    class="label-mony d-block w-100"
                  >{{form.course_price | currency}}</span>
                </div>
              </div>
              <div class="col-4">
                <div class="group-form rtl text-right">
                  <label class="statr" v-if="!form.level">سطح دوره</label>
                  <select v-validate="'required'" name="level" v-model="form.level">
                    <option value selected disabled v-if="form.level">سطح دوره</option>
                    <option
                      v-for="(option,index) in levels"
                      :value="option.id"
                      :key="index"
                    >{{option.text}}</option>
                  </select>
                  <span v-if="errors.has('level')" class="is-danger">فیلد نباید خالی باشد</span>
                </div>
              </div>
              <div class="col-4">
                <div class="group-form rtl text-right">
                  <label class="statr" v-if="!form.language">زبان دوره</label>
                  <select v-validate="'required'" name="lang" v-model="form.language">
                    <option value selected disabled v-if="form.language">زبان دوره</option>
                    <option
                      v-for="(option,index) in languages"
                      :value="option.id"
                      :key="index"
                    >{{option.text}}</option>
                  </select>
                  <span v-if="errors.has('lang')" class="is-danger">فیلد نباید خالی باشد</span>
                </div>
              </div>
              <div class="clearfix d-block w-100"></div>
              <div class="col-4">
                <div class="group-form rtl text-right">
                  <label class="statr" v-if="!form.category">دسته بندی</label>
                  <select
                    v-validate="'required'"
                    name="category"
                    v-model="form.category"
                    @change="catSelect(form.category)"
                  >
                    <option value selected disabled v-if="form.category">دسته بندی</option>
                    <option
                      v-for="(option,index) in noDuplicate"
                      :value="option.category_id"
                      :key="index"
                    >{{option.category}}</option>
                  </select>
                  <span v-if="errors.has('category')" class="is-danger">فیلد نباید خالی باشد</span>
                </div>
              </div>
              <div class="col-4">
                <div class="group-form rtl text-right">
                  <label class="statr" v-if="!form.subcategory">زیر دسته</label>
                  <select v-validate="'required'" name="subCategory" v-model="form.subcategory">
                    <option value selected disabled v-if="form.subcategory">زیر دسته</option>
                    <option
                      v-for="(option,index) in subCategories"
                      :value="option.subcategory_id"
                      :key="index"
                    >{{option.subcategory}}</option>
                  </select>
                  <span v-if="errors.has('subCategory')" class="is-danger">فیلد نباید خالی باشد</span>
                </div>
              </div>
              <div class="clearfix d-block w-100"></div>
              <div class="col-12">
                <tag-list />
              </div>
              <!-- <div class="col-4">
                                <div class="group-form rtl text-right">
                                    <label class="statr" v-if="!tag">تگ</label>
                                    <select name="tag" v-model="tag">
                                        <option value="" selected disabled v-if="tag">تگ ها</option>
                                        <option v-for="(option,index) in tagOption" :value="option" :key="index">
                                            {{option.tag}}
                                        </option>
                                    </select>
                                    <span v-if="errors.has('tag')" class="is-danger">فیلد نباید خالی باشد</span>
                                </div>
              </div>-->
              <!-- <div class="col-2">
                                <div class="text-right">
                                    <button class="bttn-material-circle mdi mdi-plus bttn-md bttn-primary" v-ripple  :title="'افزودن تگ'" @click="addTag"></button>
                                </div>
              </div>-->
              <!-- <div class="col-12">
                                <div class="tag-list my-4">
                                            <ul class="text-right">
                                                <li class="d-inline-block" v-for="(tag,index) in tags" :key="index" v-if="tags.length">
                                                    <span class="badge badge-secondary py-2 px-3 ml-2 mb-2">
                                                        {{tag.tag}}
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
              </div>-->
              <!-- <div class="col-6">
                                        <div class="input-checkbox rtl text-right">
                                            <div class="md-checkbox">
                                                <input type="checkbox" id="serial" v-model="form.serial">
                                                <label for="serial" class="font-14">آیا این دوره به صورت سریالی میباشد؟</label>
                                            </div>
                                        </div>
              </div>-->
              <div class="col-6">
                <div class="input-checkbox rtl text-right">
                  <div class="md-checkbox">
                    <input type="checkbox" id="allow_offers" v-model="form.allow_offers" />
                    <label
                      for="allow_offers"
                      class="font-14"
                    >آیا مایل به شرکت در طرح های شتابدهی هستید؟</label>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="input-checkbox rtl text-right">
                  <div class="md-checkbox">
                    <input type="checkbox" id="isMultiInst" v-model="form.isMultiInst" />
                    <label for="isMultiInst" class="font-14">آیا این دوره مدرس دیگری دارد؟</label>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="input-checkbox rtl text-right">
                  <div class="md-checkbox">
                    <input type="checkbox" id="downloadable" v-model="form.downloadable" />
                    <label for="downloadable" class="font-14">قابلیت نمایش دکمه دانلود مستقیم</label>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="text-left form-action mt-2">
                  <!-- saveBaseCourse -->
                  <button
                    v-if="form && !form.id"
                    class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
                    v-ripple
                    @click="saveBaseCourse"
                  >ذخیره و رفتن به مرحله بعد</button>
                  <button
                    v-else
                    class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
                    v-ripple
                    @click="updateBaseCourse"
                  >بروزرسانی دوره</button>
                </div>
              </div>

              <div class="col-12" v-if="form && form.id">
                <div class="text-left form-action mt-4">
                  <button
                    class="font-16 px-5 py-2 bttn-fill bttn bttn-primary"
                    v-ripple
                    @click="nextStep"
                  >رفتن به مرحله بعد</button>
                </div>
              </div>
              <!-- saveBaseCourse -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <controller-curose /> -->
  </section>
</template>

<script>
import uploadAvatar from "cp/min-component/upload-photo.vue";
import tagList from "cp/min-component/tag-list.vue";

var vm;

export default {
  name: "page-dashbord-course-form",
  components: {
    uploadAvatar,
    tagList
  },
  directives: {},
  computed: {
    // defaultImg () {
    //   return this.appUrl.media + '/' + this.form.Img
    // },
    startCourseForm() {
      return this.$store.state.dashboardCourseForm.startCourseForm;
    },
    tags() {
      return this.$store.state.dashboardTag.tagCourses;
    },
    category() {
      return this.$store.state.categories.categories;
    },
    noDuplicate() {
      let cats = [...this.$store.state.categories.categories];
      return this.removeDuplicates(cats, "category_id");
    }
  },
  data() {
    return {
      duration: {
        s: "00",
        m: "20",
        h: "2"
      },
      tagCopy: [],
      scaleImage: {
        min: 0.9,
        max: 1.3,
        size: 200
      },
      defaultImg: "../../static/img/video-lecture.png",
      uploadPercentage: 0,
      tag: "",
      //   tags: [],
      isLoading: false,
      fileImg: "",
      subCat: [],
      subCategories: [],
      money: {
        decimal: "",
        thousands: ",",
        prefix: "",
        suffix: "ریال",
        precision: 0,
        masked: false
      },

      form: {
        Img: "",
        course_title: "",
        course_title_en: "",
        course_description_lite: "",
        course_description: "",
        course_duration: "",
        course_price: "",
        level: "",
        language: "",
        category: "",
        subcategory: "",
        serial: false,
        allow_offers: false,
        isMultiInst: false,
        downloadable: false
      },
      levels: [
        { text: "مقدماتی", id: 1 },
        { text: "متوسط", id: 2 },
        { text: "پیشرفته", id: 3 },
        { text: "صفر تا 100", id: 4 }
      ],
      languages: [{ text: "فارسی", id: "Fa" }, { text: "انگلیسی", id: "En" }]
    };
  },

  mounted() {
    vm = this;

    this.checkAccess();
    if (this.hasCourse().is) {
      this.getBaseInfo();
      this.getTags();
    }
    this.isLoading = false;
    if (window.location.hostname === "localhost") {
      this.setInfo();
    }
  },
  destroyed() {
    // this.$store.commit('dashboardTag/clearTagCourses')
  },
  methods: {
    setInfo() {
      this.form = {
        course_title: "course_title",
        course_title_en: "course_title_en",
        course_description_lite: "course_description_lite",
        course_description: "course_description",
        course_duration: "20",
        course_price: "1500000",
        level: 1,
        language: "Fa",
        serial: false,
        allow_offers: false,
        isMultiInst: true,
        downloadable: false
      };
    },
    async getTags() {
      try {
        let { data } = await axios.post("/course-tags/get", {
          course_id: this.hasCourse().id
        });
        if (data.state !== 200) return;
        // this.tags = data.tags
        this.$store.commit("dashboardTag/setTagCourse", data.tags);
        if (data.tags.length > 0) {
          this.tagCopy = [...data.tags];
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getBaseInfo() {
      this.isLoading = true;
      try {
        let { data } = await axios.post("/course/get-my-course-info", {
          id: this.hasCourse().id
        });
        if (data.state !== 200) return;
        this.form = data.course_info[0];
        this.defaultImg = data.course_info[0].Img;
        this.catSelect(data.course_info[0].category);
        let duration = this.form.course_duration.split(":");
        if (duration.length > 2) {
          this.duration.h = duration[0];
          this.duration.m = duration[1];
          this.duration.s = duration[2];
        } else {
          this.duration.m = this.form.course_duration;
          this.$root.showErrorMsg({
            message: "لطفا زمان دوره را اصلاح کنید"
          });
        }
        window.sessionStorage.setItem(
          "isMultiInst",
          data.course_info[0].isMultiInst
        );
        // this.$set(this.form, 'levels', data.course_info[0].level)
        // this.$set(this.form, 'Img', data.course_info[0].Img)
        // this.form.Img = data.course_info[0].Img
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },
    nextStep(){
       if (!this.form.isMultiInst) {
          this.$router.push("/dashboard/sections");
        } else {
          this.$router.push("/dashboard/instructors");
        }
    },
    async updateBaseCourse() {
      let result = await this.$validator.validate();
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      this.isLoading = true;
      this.saveTags();
      try {
        let body = { ...this.form };
        delete body.Img;
        delete body.fullname;
        delete body.levels;
        delete body.en_subcategory;
        delete body.comments_counts;
        delete body.creator_id;
        delete body.rate;
        body.course_duration =
          this.duration.h + ":" + this.duration.m + ":" + this.duration.s;

        let { data } = await axios.post("/course/form-update", body);
        if (data.state !== 200) return;
        this.$store.commit("notifications/success", {
          message: this.$t("message.request.done"),
          title: ""
        });
        if (!this.form.isMultiInst) {
          this.$router.push("/dashboard/sections");
        } else {
          this.$router.push("/dashboard/instructors");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async saveTags() {
      try {
        let body = [];
        let tagFilter = [];
        if (this.tagCopy.length > 0) {
          tagFilter = this.tags.filter(item => !this.tagCopy.includes(item));
          body = await tagFilter.map(e => {
            return { tag: e.id };
          });
        } else {
          body = await this.tags.map(e => {
            return { tag: e.id };
          });
        }
        let { data } = await axios.post("/course-tags/add", {
          course_id: this.hasCourse().id,
          tags: body
        });
        if (data.state !== 200) return;
        this.$router.push("/dashboard/sections");
      } catch (error) {
        console.log(error);
      }
    },
    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    onEditorReady(editor) {
      editor.format("direction", "rtl");
      editor.format("align", "right");
    },
    catSelect(id) {
      vm.subCategories = [];
      this.category.forEach(e => {
        if (e.category_id == id) {
          vm.subCategories.push(e);
        }
      });
    },
    uploadFile(e) {
      var files = e.target.files;
      this.form.Img = files[0];
    },
    getFile(file) {
      if (!this.form.Img) {
        this.form.Img = file;
        // this.formBio.img = file
      } else {
        this.updatFeile(file);
      }
    },
    async updatFeile(fileData) {
      try {
        var formData = new FormData();
        formData.append("Img", fileData);
        formData.append("id", parseInt(this.hasCourse().id));
        let { data } = await axios.post("/course/update-course-img", formData, {
          onUploadProgress: function(progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          }.bind(this)
        });
        if (data.state !== 200) return;
        this.uploadPercentage = 0;
        this.$store.commit("notifications/success", {
          message: this.$t("message.request.done"),
          title: ""
        });
      } catch (error) {
        console.log(error);
      }
    },
    async saveBaseCourse() {
      // TODO validate editore
      let result = await this.$validator.validate();
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      this.isLoading = true;
      this.form.course_duration =
        this.duration.h + ":" + this.duration.m + ":" + this.duration.s;
      await this.$store.dispatch("dashboardCourseForm/startCourse", this.form);
      this.saveTags();
      this.isLoading = false;
    }
  }
};
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-dashbord-course-form {
  .box-clear;
  .validTime {
    color: @red;
    font-size: 14px;
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/new-course.vue